import {NodeCodeChunk} from "../../chunks/types/NodeCodeChunk";

export function getCodeFromNodeCodeChunk(
  nodeCodeChunk: NodeCodeChunk
): string | undefined {
  return nodeCodeChunk.content;
}
